import { isIOS } from 'react-device-detect'

import { checklistErrorTypes } from 'constants/checklist'
import { userTypes } from 'helpers/user'

import {
    Network,
    AudioVideo,
    Browser,
    Device,
    ParticipantNotAllowed,
    AudioVideo404,
} from './errors'

import { btnTypes } from '../../common/Button'
import { defaultErrorScreenProps } from '../constant'

const {
    NETWORK,
    DEVICE,
    BROWSER,
    AUDIO_VIDEO,
    AUDIO_404,
    VIDEO_404,
    USER_NOT_ALLOWED,
    TEACHER_ALREADY_PRESENT,
} = checklistErrorTypes

export default (userType = userTypes.STUDENT) => {
    const isTeacher = userType === userTypes.TEACHER

    const getAppropriateCopy = (teacherCopy, studentCopy) =>
        isTeacher ? teacherCopy : studentCopy

    return {
        [NETWORK]: {
            ...defaultErrorScreenProps,
            title: 'imposter switched off the lights?',
            subText:
                'move closer to your wifi source and try connecting to a better network.',
            ErrorComponent: () => Network,
        },
        [DEVICE]: {
            ...defaultErrorScreenProps,
            title: 'You can’t use oh. Meets on this device',
            subText: getAppropriateCopy(
                'Grab your laptop for the best experience.',
                'Grab your laptop for the best experience. you can use a phone too.'
            ),
            ErrorComponent: () => Device(userType),
        },
        [AUDIO_VIDEO]: {
            ...defaultErrorScreenProps,
            title: 'we would love to see and hear you',
            subText: 'keep your audio and video ON.',
            ErrorComponent: props => AudioVideo(props),
        },
        [BROWSER]: {
            ...defaultErrorScreenProps,
            title: isIOS
                ? 'oh. use safari'
                : 'oh. you can’t open Meets on your current browser.',
            subText: isIOS
                ? 'your current browser doesn’t like us. move to safari.'
                : 'move to Chrome.',
            ErrorComponent: () => Browser,
        },
        [USER_NOT_ALLOWED]: {
            ...defaultErrorScreenProps,
            title: 'wrong room!',
            infoCopy: "you aren't a part of this session.",
            ctaTitle: 'while you find where you need to be, explore our lobby.',
            buttonProps: {
                text: 'lobby',
                type: btnTypes.SUCCESS,
                path: `${process.env.REACT_APP_DASHBOARD_URL}`,
            },
            ErrorComponent: props => ParticipantNotAllowed(props),
        },
        [TEACHER_ALREADY_PRESENT]: {
            ...defaultErrorScreenProps,
            title: "there's someone here!",
            infoCopy: 'this class is occupied.',
            ctaTitle: 'find the right class',
            buttonProps: {
                text: 'view schedule',
                type: btnTypes.SUCCESS,
                path: `${process.env.REACT_APP_DASHBOARD_URL}/schedule`,
            },
            ErrorComponent: props => ParticipantNotAllowed(props),
        },
        [AUDIO_404]: {
            ...defaultErrorScreenProps,
            title: 'uh.oh we can’t access your microphone',
            subText: 'here are few potential solutions:',
            ErrorComponent: () => AudioVideo404(),
        },
        [VIDEO_404]: {
            ...defaultErrorScreenProps,
            title: 'uh.oh we can’t access your webcam',
            subText: 'here are few potential solutions:',
            ErrorComponent: () => AudioVideo404(),
        },
    }
}
